export default class WelcomeScreen {
    constructor() {
        this.container = null;
        this.keydownHandler = this.handleKeydown.bind(this);
        this.gamepadRafId = null;
        this.prevCrossPressed = false;
        this.gamepadConnected = false;

        this.isMobileDevice = this.detectMobileDevice();
        
        // Skip welcome screen entirely for mobile devices
        if (this.isMobileDevice) {
            console.log('Mobile device detected, skipping welcome screen');
            setTimeout(() => {
                // Dispatch event to start the game immediately
                const welcomeScreenEvent = new CustomEvent('welcome_screen_closed');
                window.dispatchEvent(welcomeScreenEvent);
                console.log('Welcome screen skipped on mobile, game started directly');
            }, 500); // Short delay to ensure the game is properly initialized
        }
    }

    detectMobileDevice() {
        const isTablet = /iPad|Android(?!.*Mobile)|Surface/i.test(navigator.userAgent);

        // Check for mobile devices
        const isMobile = /Android.*Mobile|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

        // Check screen size (tablets typically have larger screens)
        const isLargeScreen = window.matchMedia && window.matchMedia('(min-width: 600px) and (max-width: 1280px)').matches;

        return isTablet || isMobile
    }


    handleKeydown(event) {
        // Prevent WASD and Tab keys when welcome screen is visible
        if (['w', 'a', 's', 'd', 'Tab'].includes(event.key.toLowerCase())) {
            event.preventDefault();
        }
    }

    create() {
        if (this.container) return;

        // Skip welcome screen on mobile devices
        if (this.isMobileDevice) {
            console.log('create() skipped for mobile device');
            return;
        }

        // Add keyboard event listener
        document.addEventListener('keydown', this.keydownHandler);
        this.startGamepadPolling();

        // Create main container
        this.container = document.createElement('div');
        this.container.id = 'welcome-screen';
        this.container.style.position = 'fixed';
        this.container.style.top = '0';
        this.container.style.left = '0';
        this.container.style.width = '100%';
        this.container.style.height = '100%';
        this.container.style.backgroundColor = 'rgba(0, 0, 0, 0)';
        this.container.style.color = 'white';
        this.container.style.display = 'flex';
        this.container.style.flexDirection = 'column';
        this.container.style.alignItems = 'center';
        this.container.style.justifyContent = 'center';
        this.container.style.fontFamily = 'Arial, sans-serif';
        this.container.style.zIndex = '1000';

        // Create main content box
        const contentBox = document.createElement('div');
        contentBox.style.backgroundColor = 'rgba(20, 16, 10, 0.9)';
        contentBox.style.padding = '40px';
        contentBox.style.borderRadius = '6px';
        contentBox.style.width = '40%';
        contentBox.style.maxWidth = '800px';
        contentBox.style.textAlign = 'center';
        contentBox.style.marginBottom = '40px';

        // Create title
        const title = document.createElement('h1');
        title.textContent = '🚌 Play Tank Up!';
        title.style.color = '#F5E6D0';
        title.style.fontSize = '48px';
        title.style.marginBottom = '10px';
        title.style.fontWeight = 'bold';

        // Game Description section
        const linkSection = document.createElement('div');
        linkSection.style.textAlign = 'center';
        linkSection.style.fontSize = '25px';
        linkSection.style.color = 'white';
        linkSection.style.paddingTop = '0px';
        linkSection.style.paddingBottom = '0px';
        linkSection.style.color = 'white';
        linkSection.innerHTML = `<a style="color:white;" onmouseover="this.style.color='white'" onmouseout="this.style.color='white'" href="https://playtankup.com">playtankup.com</a>`;

        const authorSection = document.createElement('div');
        authorSection.style.marginBottom = '10px';
        authorSection.style.textAlign = 'center';
        authorSection.style.paddingBottom = '0px';
        authorSection.style.paddingTop = '40px';
        authorSection.innerHTML = `
        <p style="font-size: 15px; margin: 8px 0; color: #F5E6D0;">Created by <a style="color: #F5E6D0; text-decoration: none; transition: color 0.2s ease" onmouseover="this.style.color='#5BB8A6'" onmouseout="this.style.color='#F5E6D0'" href="https://x.com/junwatu">@junwatu</a> + Three.js + Claude Sonnet</p>`;

        // Game Description section
        const descriptionSection = document.createElement('div');
        descriptionSection.style.textAlign = 'center';
        descriptionSection.style.fontSize = '20px';
        descriptionSection.style.color = '#F5E6D0';
        descriptionSection.innerHTML = `
            <p >
            Navigate the desert, refuel your bus, and dodge obstacles before running out of gas. A 100% game made by AI.
            </p>
        `;

        // Start button
        const startButton = document.createElement('button');
        startButton.textContent = 'Start Driving!';
        startButton.style.marginTop = '40px';
        startButton.style.padding = '15px 30px';
        startButton.style.fontSize = '24px';
        startButton.style.backgroundColor = '#5BB8A6';
        startButton.style.color = '#F5E6D0';
        startButton.style.border = 'none';
        startButton.style.borderRadius = '6px';
        startButton.style.cursor = 'pointer';
        startButton.style.transition = 'background-color 0.2s ease';
        startButton.onmouseover = () => startButton.style.backgroundColor = '#4FA898';
        startButton.onmouseout = () => startButton.style.backgroundColor = '#5BB8A6';
        startButton.onclick = () => this.hide();

        const gamepadHint = document.createElement('div');
        gamepadHint.textContent = 'PS5: Press X to Start';
        gamepadHint.style.fontSize = '13px';
        gamepadHint.style.opacity = '0.6';
        gamepadHint.style.marginTop = '10px';
        gamepadHint.style.color = '#F5E6D0';

        const gamepadMap = document.createElement('div');
        gamepadMap.style.marginTop = '8px';
        gamepadMap.style.fontSize = '12px';
        gamepadMap.style.opacity = '0.6';
        gamepadMap.style.color = '#F5E6D0';
        gamepadMap.innerHTML = 'R2 throttle, L2 brake, R1 fire, Square reload, Triangle camera, Options settings';

        // Advertisement button
        const advertisementButton = document.createElement('button');
        advertisementButton.textContent = 'Advertise With Us';
        advertisementButton.style.marginTop = '20px';
        advertisementButton.style.padding = '10px 15px';
        advertisementButton.style.fontSize = '16px';
        advertisementButton.style.backgroundColor = 'rgba(18, 18, 18, 0.0)';
        advertisementButton.style.color = '#F5E6D0';
        advertisementButton.style.border = 'none';
        advertisementButton.style.borderRadius = '0px';
        advertisementButton.style.fontSize = '16px';
        advertisementButton.style.cursor = 'pointer';
        advertisementButton.style.textDecoration = 'underline';
        advertisementButton.onmouseover = () => advertisementButton.style.backgroundColor = 'rgba(20, 16, 10, 0.3)';
        advertisementButton.onmouseout = () => advertisementButton.style.backgroundColor = 'rgba(20, 16, 10, 0.0)';
        advertisementButton.onclick = () => {
            window.location.href = 'https://buy.polar.sh/polar_cl_fJqroIgLDSRG1arvOTsc4uXOse2tBm0Mt65mW11uQCz';
        }

        // Append all components to contentBox
        contentBox.appendChild(title);
        // contentBox.appendChild(linkSection);
        contentBox.appendChild(descriptionSection);
        contentBox.appendChild(startButton);
        contentBox.appendChild(gamepadHint);
        contentBox.appendChild(gamepadMap);
        contentBox.appendChild(authorSection);

        contentBox.appendChild(advertisementButton);

        // Add contentBox to container
        this.container.appendChild(contentBox);

        document.body.appendChild(this.container);
    }

    hide() {
        if (this.container) {
            this.container.style.display = 'none';
            // Remove keyboard event listener
            document.removeEventListener('keydown', this.keydownHandler);
            this.stopGamepadPolling();

            // Dispatch event to start the game
            const welcomeScreenEvent = new CustomEvent('welcome_screen_closed');
            window.dispatchEvent(welcomeScreenEvent);
            console.log('Welcome screen closed event dispatched');
        }

        // Create advertisement button only once
        if (!this.advertiseButton) {
            const button = document.createElement('button');
            button.id = 'advertise-button';
            button.textContent = 'Advertise With Us';
            button.style.position = 'absolute';
            button.style.top = '-1px';
            button.style.left = '50%';
            button.style.transform = 'translateX(-50%)';
            button.style.padding = '10px 15px';
            button.style.backgroundColor = 'rgba(20, 16, 10, 0.55)';
            button.style.color = '#F5E6D0';
            button.style.border = 'none';
            button.style.borderRadius = '0px';
            button.style.fontSize = '16px';
            button.style.cursor = 'pointer';
            button.style.textDecoration = 'underline';
            button.style.zIndex = '1000';

            button.onmouseover = () => {
                button.style.backgroundColor = 'rgba(20, 16, 10, 0.7)';
            };
            button.onmouseout = () => {
                button.style.backgroundColor = 'rgba(20, 16, 10, 0.55)';
            };

            button.onclick = () => {
                window.location.href = 'https://buy.polar.sh/polar_cl_fJqroIgLDSRG1arvOTsc4uXOse2tBm0Mt65mW11uQCz';
            };

            document.body.appendChild(button);
            this.advertiseButton = button;
        }
    }

    show() {
        if (this.container) {
            this.container.style.display = 'flex';
            this.startGamepadPolling();
        } else {
            this.create();
        }
    }

    dispose() {
        this.stopGamepadPolling();
        if (this.container && this.container.parentNode) {
            this.container.parentNode.removeChild(this.container);
            // Remove keyboard event listener
            document.removeEventListener('keydown', this.keydownHandler);
        }
        this.container = null;
    }

    startGamepadPolling() {
        if (this.gamepadRafId || this.isMobileDevice) return;

        const poll = () => {
            this.pollGamepadStart();
            this.gamepadRafId = requestAnimationFrame(poll);
        };
        this.gamepadRafId = requestAnimationFrame(poll);
    }

    stopGamepadPolling() {
        if (this.gamepadRafId) {
            cancelAnimationFrame(this.gamepadRafId);
            this.gamepadRafId = null;
        }
        this.prevCrossPressed = false;
    }

    pollGamepadStart() {
        const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
        if (!gamepads) return;

        const active = Array.from(gamepads).find((gp) => gp && gp.connected);
        if (!active) {
            this.prevCrossPressed = false;
            return;
        }

        const crossPressed = !!active.buttons?.[0]?.pressed;
        if (crossPressed && !this.prevCrossPressed && this.container && this.container.style.display !== 'none') {
            this.hide();
        }
        this.prevCrossPressed = crossPressed;
    }
}
